import { change } from 'redux-form';

const FORM_NAME = 'examFinalizePrescriptionForm';

const buildContactLensAttributes = (lens, side) => {
  const contactLensId = lens[`${side}_contact_lens_id`];
  if (!contactLensId) return null;

  const toArray = (value) => (value == null || value === '' ? [] : [value]);

  return {
    id: contactLensId,
    brand_name: lens[`${side}_contact_lens_brand_name`],
    lens_type: lens[`${side}_lens_type`],
    base_curves: toArray(lens[`${side}_curve`]),
    diameters: toArray(lens[`${side}_diameter`]),
    spheres: toArray(lens[`${side}_sphere`]),
    cylinder: toArray(lens[`${side}_cylinder`]),
    axis: toArray(lens[`${side}_axis`]),
    add: toArray(lens[`${side}_add`]),
    material: toArray(lens[`${side}_material`]),
    lens_power: toArray(lens[`${side}_lens_power`]),
    mf_type: toArray(lens[`${side}_mf_type`]),
    rzd1: toArray(lens[`${side}_rzd1`]),
    rzd2: toArray(lens[`${side}_rzd2`]),
    lza1: toArray(lens[`${side}_lza1`]),
    lza2: toArray(lens[`${side}_lza2`]),
    tint: toArray(lens[`${side}_tint`]),
    dot: toArray(lens[`${side}_dot`]),
    optical_zone: toArray(lens[`${side}_optical_zone`]),
    sag_dep: toArray(lens[`${side}_sag_dep`]),
    limbal: toArray(lens[`${side}_limbal`]),
    mid_peri: toArray(lens[`${side}_mid_peri`]),
    edge: toArray(lens[`${side}_edge`]),
    skirt_radius: toArray(lens[`${side}_skirt_radius`]),
  };
};

const syncLensSide = (dispatch, fieldName, side, lens) => {
  const contactLensAttributes = buildContactLensAttributes(lens, side);
  if (!contactLensAttributes) return;

  dispatch(change(FORM_NAME, `${fieldName}[${side}_contact_lens_id]`, contactLensAttributes.id));
  dispatch(change(FORM_NAME, `${fieldName}[${side}_contact_lens_brand_name]`, contactLensAttributes.brand_name));
  dispatch(change(FORM_NAME, `${fieldName}[${side}_contact_lens_attributes]`, contactLensAttributes));
  if (contactLensAttributes.lens_type != null) {
    dispatch(change(FORM_NAME, `${fieldName}[${side}_lens_type]`, contactLensAttributes.lens_type));
  }
};

export const syncImportedContactLensPrescription = (dispatch, sourceLenses = []) => {
  sourceLenses.forEach((lens, index) => {
    const fieldName = `finalized_lenses_attributes[${index}]`;
    syncLensSide(dispatch, fieldName, 'od', lens);
    syncLensSide(dispatch, fieldName, 'os', lens);
  });
};
